// The Feedback HTTP wire contract (Slice 6; slice-plan.md:83-92; D45; ADR-0023).
//
// The SINGLE source of truth for the Feedback routes apps/api (producer) and apps/web (consumer)
// build against. Success payloads are the domain schemas from ../model/feedback.js; every failure
// returns the shared `ErrorEnvelope { code, message }` (http/knowledge.ts:21) - a byte-identical
// not-found on an app that is not the caller's (app-security §2 A01).
import { z } from "zod";
import { AppId } from "../ids.js";
import { NonEmptyString } from "../model/common.js";
import { FeedbackKind, FeedbackSource } from "../model/enums.js";
import { FeedbackOverview, FeedbackSubmission } from "../model/feedback.js";
/** The canonical route path strings, for the api lane to register verbatim (D2). */
export const FEEDBACK_ROUTES = {
    overview: "/v1/apps/:appId/feedback-overview",
    submit: "/v1/apps/:appId/feedback",
};
/** Path params for the app-scoped Feedback routes: the one app the request is scoped to. */
export const FeedbackRouteParams = z.object({ appId: AppId });
// --- Feedback overview: GET /v1/apps/:appId/feedback-overview ---
/** 200 -> the `FeedbackOverview` (themes, top requests, the D45 escalation state), else an `ErrorEnvelope`. */
export const FeedbackOverviewResponse = FeedbackOverview;
// --- Submit: POST /v1/apps/:appId/feedback (founder-supplied only, D45) ---
/**
 * POST body: a founder-supplied feedback item (D45's three founder entry methods: a manual note
 * from a call, a forwarded customer email, or a support-export/CSV import). `source` is WIDENED to
 * the founder-supplied subset of `FeedbackSource` (enums.ts:218) via `.extract` - `founder_note`,
 * `email`, `import` - so it stays derived from the one canonical enum rather than a hand-rolled
 * duplicate. `widget` is deliberately EXCLUDED: a founder submitting through THIS route can never
 * masquerade as the in-app beacon widget, which lands through its own ingest surface, not here.
 */
export const FeedbackSubmitRequestBody = z.object({
    kind: FeedbackKind,
    body: NonEmptyString,
    source: FeedbackSource.extract(["founder_note", "email", "import"]),
    sourceRef: NonEmptyString.nullable(),
});
/** 200 -> the recorded `FeedbackSubmission`, else an `ErrorEnvelope`. */
export const FeedbackSubmitResponse = FeedbackSubmission;
//# sourceMappingURL=feedback.js.map